export const agentTypes = {
  prepaid: 'prepaid',
  postpaid: 'postpaid',
}
